import { EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_TARGET_PARTS } from '../config/exploreUnknownRewriteExperience';
import { buildDevAfterBattleNavigateState } from './buildDevAfterBattleNavigateState';

/**
 * Dev-only (player1): navigation state for AfterBattle EU victory reward flows (UI only).
 *
 * @param {{ activeRunId?: number|null, committedStrategyId?: string|number|null, missionIndex?: number }} options
 * @returns {object}
 */
export function buildExploreUnknownDevMockWinAfterBattleNavigateState(options = {}) {
  const runId = options.activeRunId != null ? Number(options.activeRunId) : 1;
  const missionIndex = options.missionIndex != null ? Number(options.missionIndex) : 10;
  const strategyId = options.committedStrategyId;

  const exploreUnknownXpGrant = {
    xpGained: 250,
    totalXp: 1250,
    levelBefore: 4,
    levelAfter: 6,
    leveledUp: true,
    xpIntoLevelBefore: 80,
    xpToNextBefore: 200,
    xpIntoLevel: 30,
    xpToNext: 180,
    newMilestones: [5, 6],
    nextLevelMilestoneBonus: {
      level: 10,
      bonusId: 'childhood_memories_l10',
      icon: '/images/happy.jpg',
      i18nKey: 'levelBonus10',
    },
    legendaryOrderUnlockReward: {
      popupId: 'dev-mock-eu-legendary-l30',
      rewardType: 'order',
      orderId: 299,
      orderName: 'Dev Legendary (mock)',
      source: 'legendaryOrderUnlock',
    },
    bonusOrderRewards: [
      {
        popupId: 'dev-mock-eu-bonus-order',
        rewardType: 'order',
        orderId: 322,
        orderName: 'Dev Bonus Order (mock)',
        source: 'devMock',
      },
      {
        popupId: 'dev-mock-eu-bonus-billy',
        rewardType: 'billy_bucks',
        amount: 500,
        source: 'devMock',
      },
    ],
    rewriteFragmentMapProcGranted: true,
    rewriteExperiencePartsCollected: EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_TARGET_PARTS,
    rewriteExperienceSetCompletedFromMapProc: true,
    rewriteExperienceCharges: 2,
    epFragmentMapProcGranted: true,
    epFragmentMapProcBonusId: 'epGlobal',
    epFragmentMapProcPartsCollected: 3,
    epFragmentMapProcTargetParts: 3,
    epFragmentMapProcSetCompleted: true,
    epFragmentMapProcCharges: 1,
  };

  const rewards = [
    {
      type: 'order',
      data: {
        id: 1,
        name: 'Dev Mission Order',
        rarity: 'rare',
        type: 'unit',
        cost: 5,
        attack_rating: 3,
        health: 4,
        faction_id: 1,
        faction_name: 'Remnants of Humanity',
        description: 'Mock EU win battle reward',
      },
    },
    {
      type: 'billy_bucks',
      amount: 150,
      data: { amount: 150 },
    },
  ];

  const gameState = {
    exploreUnknownMissionIndex: missionIndex,
    exploreUnknownRunId: runId,
    exploreUnknownXpGrant,
    exploreUnknownBossWinDarknessReductionPercent: 10,
    exploreUnknownBossWinDarknessMeterFromPct: 45,
    exploreUnknownBossWinDarknessMeterToPct: 35,
    exploreUnknownRefinedErrayBossDrop: { missionIndex },
    exploreUnknownMemoryDarknessReductionTotal: 0,
    exploreUnknownRunDarknessPercent: 35,
    state: {},
  };

  const uid =
    typeof localStorage !== 'undefined' ? localStorage.getItem('userId') : null;
  const numUid = uid != null ? parseInt(uid, 10) : NaN;
  if (strategyId != null && strategyId !== '') {
    const strategyPayload = { strategy: { id: strategyId } };
    if (uid) gameState.state[uid] = strategyPayload;
    if (!Number.isNaN(numUid)) {
      gameState.state[numUid] = strategyPayload;
      gameState.state[String(numUid)] = strategyPayload;
    }
  }

  return buildDevAfterBattleNavigateState(
    {
      result: 'win',
      exploreUnknownRun: true,
      devExploreUnknownWinMock: true,
      exploreUnknownRefinedErrayBossDrop: gameState.exploreUnknownRefinedErrayBossDrop,
      exploreUnknownXpGrant,
      rewards,
      gameState,
      strategyId: strategyId ?? undefined,
      isFriendlyMatch: false,
      isTournamentMatch: false,
    },
    { playerFactionName: 'Remnants of Humanity' }
  );
}
